// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
#map {
        max-height: calc(100vh - 200px);
}
.blink {
        animation-name: blink;
        animation-duration: 1s;
        animation-iteration-count: 3;
}
@keyframes blink {
0% {
            color: red
}
50% {
            color: rgba(0,0,0,0);
}
100% {
            color: red;
}
}

`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
